import { render, staticRenderFns } from "./WebsiteSetupList.vue?vue&type=template&id=3f99fcc4&scoped=true&"
import script from "./WebsiteSetupList.vue?vue&type=script&lang=js&"
export * from "./WebsiteSetupList.vue?vue&type=script&lang=js&"
import style0 from "./WebsiteSetupList.vue?vue&type=style&index=0&id=3f99fcc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f99fcc4",
  null
  
)

export default component.exports